import React, {Component} from 'react';
import '../public/less/forms.less';
import '../public/less/userDetails.less';
import DoctorDetails from './doctorSummary/DoctorDetails';
import DoctorAdvices from './doctorSummary/DoctorAdvices';
import DoctorCharts from './doctorSummary/DoctorCharts';

module.exports = class doctorSummary extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        var doctorID = this.props.params.userID;
        return (
            <div>
                <DoctorDetails doctorID={doctorID}/>
                <div className='container'>
                    <h3 className='padding30'>Patients info</h3>
                    <DoctorAdvices doctorID={doctorID}/>
                    <hr/>
                    <DoctorCharts doctorID={doctorID}/>

                </div>
            </div>
        )
    }
};







// WEBPACK FOOTER //
// ./modules/doctorSummary.jsx